module.exports = __webpack_public_path__ + "static/img/presa.b033dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/presa.png
// module id = 457
// module chunks = 1